import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { Validators, DatePickerRangeField } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t?: Function;
};

const SearchHistoryLogAlerts = (props: InjectedFormProps & ConnectedProps) => {
    const { handleSubmit, pristine, submitting, t } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field
                name="dateRangeFromTo"
                component={DatePickerRangeField}
                type="text"
                placeholder={t('dateRange')}
                label={t('dateRange')}
                validate={[Validators.required]}
                endDateLabel={t('endDate')}
                startDateLabel={t('startDate')}
            />
            <div className="flex flex--center flex--justify-right">
                <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                    {t('generate')}
                </button>
            </div>
        </form>
    );
};

function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}




export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'SearchHistoryLogAlerts',
        enableReinitialize: true
    })
)(SearchHistoryLogAlerts) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/SearchHistoryLogAlerts.tsx